import { config } from '@web/config/env';
import { BuildType } from '@web/redux/Development';
import { selectBuildType } from '@web/redux/selectors';
import { useAppSelector } from '@web/redux/store';
import { useLocation } from 'react-router';
import { JoinUsDialogContent } from './JoinUsDialogContent';
import { useJoinUsLocalStorage } from './join-us-storage';

export default function JoinUsDialog() {
  const { date, setJoinUsDate } = useJoinUsLocalStorage();
  const buildType = useAppSelector(selectBuildType);
  const { pathname } = useLocation();
  const isJoinUsDialogVisible = !(pathname.includes('external-auth') || pathname.includes('privacy') || pathname.includes('deep-linking'));
  const open = config.joinUsModalEnabled && (!date || date <= new Date()) && buildType === BuildType.default && isJoinUsDialogVisible;
  // The external auth page will set the build type

  return (
    <JoinUsDialogContent
      open={open}
      onOk={() => {
        setJoinUsDate(1);
      }}
      onRemindMeLater={() => {
        setJoinUsDate(1);
      }}
    />
  );
}
